export const US_STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const NON_REGISTRATION_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CO',
  'DE',
  'GA',
  'ID',
  'IA',
  'KS',
  'MA',
  'MS',
  'MO',
  'MT',
  'NV',
  'NH',
  'NJ',
  'NM',
  'OH',
  'OK',
  'OR',
  'PA',
  'TN',
  'VT',
  'WV',
  'WY',
];

export const FILLING_STATES = [
  'CT',
  'FL',
  'KY',
  'LA',
  'ME',
  'NE',
  'NC',
  'SC',
  'SD',
  'TX',
  'UT',
];

export const REGISTRATION_STATES = [
  'CA',
  'HI',
  'IL',
  'IN',
  'MD',
  'MI',
  'MN',
  'NY',
  'ND',
  'RI',
  'VA',
  'WA',
  'WI',
];
